import { GetRelationshipRequest } from './GetRelationshipRequest'

export class RelationshipModel extends GetRelationshipRequest {

}